enum AccessReportsAdminVersionTypeEnum {
  CurrentVersion = "Current Version",
  InProgressVersion = "In-Progress Version",
}

export { AccessReportsAdminVersionTypeEnum };
